import { AES, enc } from 'crypto-js';
import constants from './constants';

export const symmetricEncrypt = (value) => {
    return AES.encrypt(value, constants.CRYPTO_KEY).toString();
};

export const symmetricdecrypt = (value) => {
    return AES.decrypt(value, constants.CRYPTO_KEY).toString(enc.Utf8);
};
